import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
    {
        q: "Est-ce de la triche ?",
        a: "Utiliser un outil n'est pas tricher en soi ; c'est ce qu'on en fait qui compte. Une calculatrice n'a jamais empêché d'apprendre les mathématiques. La question pertinente n'est pas « est-ce permis ? » mais « apprend-on quelque chose en s'en servant ? ». Le contexte (examen, devoir, vie professionnelle) impose ensuite ses règles propres.",
    },
    {
        q: "L'IA remplace-t-elle l'intelligence ?",
        a: "Non. Elle ne pense pas à votre place. Elle reformule, propose, structure, à partir de ce que vous lui donnez. Sans intention, sans contexte, sans relecture humaine, sa sortie n'a pas plus de valeur qu'un texte générique. La pensée critique, le jugement et la décision restent humains.",
    },
    {
        q: "Risque-t-on une dépendance ?",
        a: "Comme avec tout outil utile, l'usage doit rester conscient. Le bon repère est simple : un outil est sain s'il élargit votre autonomie au lieu de la rétrécir. Si vous ne pouvez plus rien faire sans lui, l'usage doit être réinterrogé. Si, au contraire, il vous permet d'aller là où vous n'alliez plus, il est probablement à sa place.",
    },
    {
        q: "Les élèves et étudiants devraient-ils pouvoir utiliser ces outils ?",
        a: "Interdire un outil largement disponible est rarement efficace ; en organiser l'usage, l'expliciter et l'évaluer l'est davantage. Le débat ne devrait pas opposer « avec » et « sans », mais distinguer les moments où l'on apprend à penser sans aide, et ceux où l'on apprend à travailler avec les outils que la vie professionnelle utilisera de toute façon.",
    },
    {
        q: "Que faire face aux erreurs ou aux hallucinations ?",
        a: "Considérer chaque réponse comme une hypothèse, jamais comme une certitude. Croiser les sources, vérifier les chiffres, les références et les citations. Ne pas confier à l'IA ce qui demande une garantie de véracité (santé, droit, sécurité, données sensibles) sans une vérification humaine compétente.",
    },
    {
        q: "Et la confidentialité ?",
        a: "Aucun outil ne devrait recevoir des informations sensibles dont la diffusion poserait problème. Données médicales, juridiques, professionnelles confidentielles : à manier avec précaution, en privilégiant des solutions dont la politique de traitement des données est claire.",
    },
];

/**
 * FAQ — accordéon pur, sans en-tête éditorial.
 * L'en-tête (eyebrow + H1 + lead) est porté par la page parente via PageHeader.
 */
export default function FAQ() {
    return (
        <section
            data-testid="faq-section"
            id="faq"
            className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 pb-16 md:pb-20"
        >
            <Accordion
                type="multiple"
                defaultValue={faqs.map((_, i) => `faq-${i}`)}
                className="border-t border-[#0D1B2A]/15"
            >
                {faqs.map((f, i) => (
                    <AccordionItem
                        key={f.q}
                        value={`faq-${i}`}
                        data-testid={`faq-item-${i}`}
                        className="border-b border-[#0D1B2A]/15 rounded-none"
                    >
                        <AccordionTrigger className="hover:no-underline py-6 group">
                            <span className="flex gap-6 items-baseline text-left">
                                <span className="editorial-num text-sm shrink-0">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <span className="font-serif text-xl md:text-2xl text-[#0D1B2A] group-hover:text-[#415A77] transition-colors">
                                    {f.q}
                                </span>
                            </span>
                        </AccordionTrigger>
                        <AccordionContent className="pb-8 pl-[3.5rem] pr-2 text-[#1B263B] text-base md:text-lg leading-relaxed">
                            {f.a}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </section>
    );
}
